var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27233 0.854796C6.96551 0.470854 7.83086 0.693949 8.25608 1.34829L8.31128 1.44017L13.4839 10.779C13.6071 11.0014 13.6718 11.2515 13.6718 11.5058C13.6718 12.2997 13.055 12.9496 12.2745 13.0023L12.1718 13.0058H1.82792C1.57371 13.0058 1.32368 12.9412 1.10129 12.8181C0.40806 12.4342 0.138033 11.5823 0.46707 10.8747L0.515668 10.7792L5.68686 1.44033C5.82322 1.19409 6.0261 0.991177 6.27233 0.854796ZM7.0003 9.66788C6.6326 9.66788 6.33452 9.96596 6.33452 10.3337C6.33452 10.7014 6.6326 10.9994 7.0003 10.9994C7.368 10.9994 7.66607 10.7014 7.66607 10.3337C7.66607 9.96596 7.368 9.66788 7.0003 9.66788ZM6.99886 4.33206C6.65697 4.33218 6.37528 4.58965 6.33689 4.92122L6.33243 4.99897L6.33363 8.33289L6.33815 8.41063C6.37678 8.74218 6.65865 8.99944 7.00054 8.99931C7.34243 8.99919 7.62412 8.74173 7.66251 8.41016L7.66697 8.33241L7.66577 4.99849L7.66125 4.92074C7.62262 4.5892 7.34075 4.33194 6.99886 4.33206Z",
    fill: "#49484D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncident);
export default __webpack_public_path__ + "static/media/incident.9965244eef43c06a51146ce788707b53.svg";
export { ForwardRef as ReactComponent };